export default __webpack_public_path__ + "static/Anton Hidayat-492ff760f4937e47ea6003ab1f516cb3.webp";